export default __webpack_public_path__ + "static/media/aboutBg3.737ce6a7.png";